module.exports = ["cent","copy","divide","gt","lt","not","para","times"]


//////////////////
// WEBPACK FOOTER
// ./~/stringify-entities/dangerous.json
// module id = 885
// module chunks = 168707334958949